import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";
import { getClientId } from "./utils/analyticsclientIdUtils";
import ZPartner02Header from "./ZPartner02Header";
import ZPartner02Footer from "./ZPartner02Footer";

export class ZPartner02Home extends Component {
    static displayName = ZPartner02Home.name;

    constructor(props) {
        super(props);
        this.state = {
            refUserId: "",
            switchBackUrl: "",
            termsChecked: false,
        };

        this.handleTermsChange = this.handleTermsChange.bind(this);
        this.handleSubmitYes = this.handleSubmitYes.bind(this);
        this.handleSubmitNo = this.handleSubmitNo.bind(this);
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "Partner02_Home";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        // Read query string parameters
        const params = new URLSearchParams(window.location.search);
        const refUserId = params.get("refUserId");
        const switchBackUrl = params.get("switchBackUrl");

        // If any required parameter is missing, redirect to error page
        if (!refUserId || !switchBackUrl) {
            window.location.replace("/x02lineman/Error?S=param");
        }

        // Save values into state
        this.setState({ refUserId, switchBackUrl });

        this.chkPartnerLinkExists(refUserId);
    }

    chkPartnerLinkExists = async (refUserId) => {
        try {
            const timestamp = Math.floor(Date.now() / 1000);
            // Payload api
            const payload = {
                refUserId: refUserId,
                partnerCode: "002",
                Timestamp: timestamp
            };

            const encryptedPayload = encryptData(payload);

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
            };
            const response = await fetch(`/api/ZPartnerCheckLinkExists`, requestOptions);
            const data = await response.json();
            //console.log(data);
            if (data.responseCode === "00") {
                //success api -> chk got linkUd or not
                if (data.responseMessage !== "0") {
                    //already link
                    window.location.replace("/x02lineman/Error?S=alreadylink");
                }
                else {
                    this.setState({ jcheck: "done" });
                }
            }
            else {
                //fail api
                window.location.replace("/x02lineman/Error?S=api");
            }
        } catch (e) {
            window.location.replace("/x02lineman/Error?S=" + e);
        }
    }

    handleTermsChange(event) {
        this.setState({ termsChecked: event.target.checked });
    }

    handleSubmitYes(event) {
        event.preventDefault();
        if (!this.state.termsChecked) return;

        this.props.history.push({
            pathname: "/X02LINEMAN/MemberSignIn",
            state: {
                refUserId: this.state.refUserId,
                switchBackUrl: this.state.switchBackUrl
            }
        });
    }

    handleSubmitNo(event) {
        event.preventDefault();
        if (!this.state.termsChecked) return;

        this.props.history.push({
            pathname: "/X02LINEMAN/MemberNew",
            state: {
                refUserId: this.state.refUserId,
                switchBackUrl: this.state.switchBackUrl
            }
        });
    }

    render() {
        const { refUserId, switchBackUrl, termsChecked } = this.state;

        return (
            <>
                <ZPartner02Header />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">ข้อกำหนดและเงื่อนไขเกี่ยวกับการผูกบัญชีสมาชิก LINE MAN และ Starbucks® Rewards</h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3 ">
                                    <div className="py-5 p-4 box-sign-in text-break">
                                        <p>1 บัญชีสมาชิก LINE MAN สามารถทำการผูกกับ 1 บัญชีสมาชิก Starbucks® Rewards ต่อครั้งเท่านั้น </p>
                                        <p>เมื่อทำการผูกบัญชีสมาชิกไว้ด้วยกันแล้ว จะสามารถสะสมดาวในโปรแกรม Starbucks® Rewards เมื่อมีการซื้อสินค้าสตาร์บัคส์ที่อยู่บนแอปพลิเคชัน LINE MAN และเป็นร้านที่สร้างขึ้นโดย บริษัท คอฟฟี่ คอนเซ็ปต์ รีเทล จำกัด โดยทุก ๆ 50 บาทของการใช้จ่าย สมาชิก Starbucks® Rewards จะได้รับดาว Starbucks® Rewards 1 ดวง </p>
                                        <p>ยอดใช้จ่ายที่นำมาคำนวณดาว จะคำนวณจากยอดใช้จ่ายสุทธิในใบเสร็จที่ออกโดย บริษัท คอฟฟี่ คอนเซ็ปต์ รีเทล จำกัด เท่านั้นไม่รวมค่าบริการจัดส่ง</p>
                                        <p>การซื้อสินค้าสตาร์บัคส์ที่อยู่บนแอปพลิเคชัน LINE MAN และเป็นร้านที่สร้างขึ้นโดย บริษัท คอฟฟี่ คอนเซ็ปต์ รีเทล จำกัด จะไม่เข้าร่วมกิจกรรมส่งเสริมการขายใด ๆ ที่เกิดขึ้น ณ ร้านสตาร์บัคส์ เว้นแต่สตาร์บัคส์จะกำหนดเป็นอย่างอื่นไว้เป็นการเฉพาะ และไม่ถือเป็นการใช้จ่าย ณ ร้านสตาร์บัคส์ เพื่อรับดาว หรือดาวโบนัส สำหรับการซื้อ ณ ร้านสตาร์บัคส์</p>
                                        <p>หากคุณมีบัญชีสมาชิก Starbucks® Rewards แล้ว กรุณาคลิกปุ่มด้านล่างซ้าย เพื่อทำการกรอกอีเมล และรหัสผ่านของบัญชีสมาชิก Starbucks® Rewards  เพื่อผูกบัญชีสมาชิก LINE MAN กับบัญชีสมาชิก Starbucks® Rewards หลังจากนั้นคุณสามารถสะสมดาวในโปรแกรม Starbucks® Rewards ได้</p>
                                        <p>หากคุณยังไม่มีบัญชีสมาชิก Starbucks® Rewards กรุณาคลิกที่ปุ่มด้านล่างขวา เพื่อสมัครลงทะเบียนสมาชิก Starbucks® Rewards และผูกบัญชีสมาชิก หลังจากนั้นคุณสามารถสะสมดาวในโปรแกรม Starbucks® Rewards ได้</p>
                                        <p>ในกรณีต้องการนำบัญชีสมาชิก Starbucks® Rewards ที่ผูกกับบัญชีสมาชิก LINE MAN ไว้แล้ว ไปทำการผูกกับบัญชีสมาชิกอื่นของ LINE MAN จะต้องทำการยกเลิกการผูกบัญชี Starbucks® Rewards  เดิมก่อน จึงจะสามารถนำบัญชีสมาชิก Starbucks® Rewards ไปผูกกับบัญชีสมาชิกอื่นของ LINE MAN ได้ </p>
                                        <p>ในกรณีบัญชีสมาชิก Starbucks® Rewards หรือบัญชีสมาชิก LINE MAN ถูกยกเลิกการเป็นสมาชิก ระบบจะทำการยกเลิกการผูกบัญชีสมาชิกนั้นทันที และท่านจะไม่สามารถสะสมดาวในโปรแกรม Starbucks® Rewards ผ่านการซื้อสินค้าสตาร์บัคส์ที่อยู่บนแอปพลิเคชัน LINE MAN ในครั้งถัดไปได้</p>
                                        <p>ข้อกำหนดและเงื่อนไขนี้จัดทำขึ้นเป็นภาษาไทยและภาษาอังกฤษ ในกรณีที่มีข้อขัดแย้งระหว่างข้อกำหนดและเงื่อนไขนี้ฉบับภาษาอังกฤษ และฉบับภาษาไทย ให้ยึดตามฉบับภาษาอังกฤษ</p>
                                        <p>
                                            เงื่อนไขข้อกำหนดอื่น ๆ ระหว่างคุณกับสตาร์บัคส์ที่เกี่ยวข้องกับ 1) ข้อกำหนดการใช้ Starbucks® Rewards 2) ข้อกำหนดในการใช้และสัญญาบัญชี Starbucks Card และ 3) นโยบายคุ้มครองข้อมูลส่วนบุคคล ให้อยู่ภายใต้บังคับข้อกำหนดเงื่อนไขที่ระบุบนเว็บไซต์ของสตาร์บัคส์ประเทศไทย ดังนี้ <br />
                                            1) 	<a href="https://rewards.starbucks.co.th/thtermsofuse">https://rewards.starbucks.co.th/thtermsofuse</a><br />
                                            2) 	<a href="https://rewards.starbucks.co.th/thterms">https://rewards.starbucks.co.th/thterms</a><br />
                                            3) 	<a href="https://www.starbucks.co.th/th/online-policies/privacy-notice/">https://www.starbucks.co.th/th/online-policies/privacy-notice/</a>
                                        </p>
                                        <p>	</p>
                                        <p>Terms and conditions for linking LINE MAN account to Starbucks® Rewards Program</p>
                                        <p>One (1) LINE MAN account can only be linked to One (1) Starbucks® Rewards account at a time.</p>
                                        <p>When you have linked your LINE MAN account with Starbucks® Rewards program, you will earn 1 Star on every 50 Baht spent on Starbucks products from Starbucks shop created by Coffee Concept Retail Co., Ltd. on LINE MAN Application.</p>
                                        <p>The Stars will be calculated from the total amount shown on the original receipt issue by Coffee Concept Retail Co., Ltd. Only exclude delivery fee. </p>
                                        <p>
                                            Any promotional activities that take place at Starbucks stores shall not apply to all purchases of Starbucks products from Starbucks shop created by Coffee Concept Retail Co., Ltd. on LINE MAN Application unless otherwise indicated specifically by Starbucks.  Such purchases shall not be qualified to earn same number of Stars or Bonus Stars as spending in Starbucks stores.<br />
                                            <br />
                                            If you are a member of Starbucks® Rewards program, please click on the button on the bottom left to log in your “Starbucks® Rewards” account with your username (email) and password and link your LINE MAN account with Starbucks® Rewards program.  Afterwards, you will earn Star from Starbucks® Rewards program on your Starbucks order via LINE MAN Application.
                                        </p>
                                        <p>If you are not a member of Starbucks® Rewards program, please click on the button on the bottom right to register for your Starbucks® Rewards account and link your LINE MAN account with Starbucks® Rewards program.  Afterwards, you will earn Star from Starbucks® Rewards program on your Starbucks order via LINE MAN Application.</p>
                                        <p>You can reapply to another LINE MAN account with the existing Starbucks® Rewards account by unlinking your current LINE MAN account with your Starbucks® Rewards account. </p>
                                        <p>In the event that your Starbucks® Rewards account or LINE MAN account is terminated, the system will immediately delink the two accounts and you will not be entitled to earn Starbucks® Rewards Stars earned through your next Starbucks purchase on the LINE MAN Application. </p>
                                        <p>These terms and conditions were made in Thai and English.  In case of any conflict between the provisions of the English version of these Terms and Conditions and and Thai version, the English version will prevail.</p>
                                        <p>
                                            Other terms and condition in connection with 1) Starbucks® Rewards 2) Starbucks Card Account Terms of Use and Agreement; and 3) Starbucks Privacy Notice shall be governed under the standard terms and conditions set forth on Starbucks Thailand website with the following URL: <br />
                                            1)	<a href="https://rewards.starbucks.co.th/termsofuse">https://rewards.starbucks.co.th/termsofuse</a><br />
                                            2)	<a href="https://rewards.starbucks.co.th/terms">https://rewards.starbucks.co.th/terms</a><br />
                                            3)	<a href="https://www.starbucks.co.th/online-policies/privacy-notice/">https://www.starbucks.co.th/online-policies/privacy-notice/</a>
                                        </p>

                                        <div className="form-check mb-4">
                                            <label className="form-check-label">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={termsChecked}
                                                    onChange={this.handleTermsChange}
                                                />{" "}
                                                รับทราบข้อตกลงและเงื่อนไข / I have read and agreed to the Terms &amp; Conditions.
                                            </label>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-pill px-4 w-100 mb-3"
                                                    onClick={this.handleSubmitYes}
                                                    disabled={!termsChecked}
                                                >
                                                    เป็นสมาชิก / Yes
                                                </button>
                                            </div>
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-pill px-4 w-100"
                                                    onClick={this.handleSubmitNo}
                                                    disabled={!termsChecked}
                                                >
                                                    ไม่เป็นสมาชิก / No
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div style={{ marginTop: 24 }}>*/}
                        {/*    <small>*/}
                        {/*        Debug: Ref01 = {refUserId || "(empty)"} <br />*/}
                        {/*        ref02 = {switchBackUrl || "(empty)"}*/}
                        {/*    </small>*/}
                        {/*</div>*/}
                    </section>
                </main>

                <ZPartner02Footer />
            </>

        );
    }
}
